var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("surchargeAndMiscellaneous.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.formRules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("surchargeAndMiscellaneous.por"),
                            prop: "por",
                          },
                        },
                        [
                          _c("gl-port", {
                            model: {
                              value: _vm.form.por,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "por", $$v)
                              },
                              expression: "form.por",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "surchargeAndMiscellaneous.destination"
                            ),
                            prop: "del",
                          },
                        },
                        [
                          _c("gl-port", {
                            model: {
                              value: _vm.form.del,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "del", $$v)
                              },
                              expression: "form.del",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("surchargeAndMiscellaneous.costType"),
                            prop: "costType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.freightType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "freightType", $$v)
                                },
                                expression: "form.freightType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "surchargeAndMiscellaneous.surcharge"
                                  ),
                                  value: "4",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "surchargeAndMiscellaneous.miscellaneous"
                                  ),
                                  value: "5",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("surchargeAndMiscellaneous.paidType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.paidType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "paidType", $$v)
                                },
                                expression: "form.paidType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("surchargeAndMiscellaneous.pp"),
                                  value: "PP",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("surchargeAndMiscellaneous.cc"),
                                  value: "CC",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("surchargeAndMiscellaneous.boxPile"),
                            prop: "containerType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.containerType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "containerType", $$v)
                                },
                                expression: "form.containerType",
                              },
                            },
                            _vm._l(_vm.containerList, function (item) {
                              return _c("el-option", {
                                key: item.index,
                                attrs: {
                                  label: item.equipmentCode,
                                  value: item.equipmentCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "surchargeAndMiscellaneous.transitClause"
                            ),
                            prop: "transitClause",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.transitClause,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "transitClause", $$v)
                                },
                                expression: "form.transitClause",
                              },
                            },
                            _vm._l(_vm.transitClauseList, function (item) {
                              return _c("el-option", {
                                key: item.index,
                                attrs: {
                                  label: item.serviceModeCode,
                                  value: item.serviceModeCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "surchargeAndMiscellaneous.cargoType"
                            ),
                            prop: "cargoType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", clearable: "" },
                              model: {
                                value: _vm.form.cargoType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "cargoType", $$v)
                                },
                                expression: "form.cargoType",
                              },
                            },
                            _vm._l(_vm.cargoTypeList, function (item) {
                              return _c("el-option", {
                                key: item.index,
                                attrs: {
                                  label: _vm.isCnLang
                                    ? item.cargoTypeNameCn
                                    : item.cargoTypeName,
                                  value: item.cargoTypeCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "margin-top": "28px",
                        "text-align": "right",
                      },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-plain-primary",
                          attrs: { type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.exportHandle()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("surchargeAndMiscellaneous.exportExcel")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.isResult
      ? _c(
          "div",
          {
            staticClass: "result-container",
            staticStyle: { "padding-bottom": "20px" },
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-bottom": "10px" } },
              [
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("surchargeAndMiscellaneous.title"))),
                ]),
                _vm._v("   "),
                _c("span", { staticStyle: { color: "blue" } }, [
                  _vm._v(_vm._s(_vm.$t("surchargeAndMiscellaneous.result"))),
                ]),
                _vm._v("  \n      "),
                _c(
                  "span",
                  { staticStyle: { color: "red", "font-size": "12px" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("surchargeAndMiscellaneous.supplement"))
                    ),
                  ]
                ),
                _vm._v("  \n      "),
                _c(
                  "el-checkbox",
                  {
                    on: { change: _vm.toSearch },
                    model: {
                      value: _vm.showDefault,
                      callback: function ($$v) {
                        _vm.showDefault = $$v
                      },
                      expression: "showDefault",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("surchargeAndMiscellaneous.defaultPaidType")
                      ) + "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "default-sort": _vm.sortRule,
                  id: "out-charge-table",
                  stripe: "",
                  border: "",
                },
                on: { "sort-change": _vm.sortChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "por",
                    label: _vm.$t("surchargeAndMiscellaneous.por"),
                    "min-width": "10%",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "del",
                    label: _vm.$t("surchargeAndMiscellaneous.del"),
                    "min-width": "10%",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "containerType",
                    label: _vm.$t("surchargeAndMiscellaneous.containerType"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "",
                    sortable: true,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "affixChargeType",
                    label: _vm.$t("surchargeAndMiscellaneous.chargeCode"),
                    "min-width": "16%",
                    "show-overflow-tooltip": "",
                    sortable: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isCnLang
                                    ? scope.row.affixChargeType
                                    : scope.row.affixChargeTypeEn
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2706753632
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "displayValueCn",
                    label: _vm.$t("surchargeAndMiscellaneous.costType"),
                    "min-width": "10%",
                    sortable: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isCnLang
                                    ? scope.row.displayValueCn
                                    : scope.row.displayValue
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1194859750
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cargoType",
                    label: _vm.$t("surchargeAndMiscellaneous.cargoType"),
                    "min-width": "18%",
                    "show-overflow-tooltip": "",
                    sortable: true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isCnLang
                                    ? scope.row.cargoType
                                    : scope.row.cargoTypeEn
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3904560480
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "rate",
                    label: _vm.$t("surchargeAndMiscellaneous.rate"),
                    "min-width": "10%",
                    "show-overflow-tooltip": "",
                    sortable: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(scope.row.rate) +
                                " " +
                                _vm._s(scope.row.currency) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3894863253
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "serviceModeCode",
                    label: _vm.$t("surchargeAndMiscellaneous.transitClause"),
                    "min-width": "10%",
                    sortable: "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "paidType",
                    label: _vm.$t("surchargeAndMiscellaneous.paidType"),
                    "min-width": "9%",
                    sortable: "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "text-align": "center", "padding-top": "10px" },
              },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.page.pageIndex,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.page.pageSize,
                    layout: "total,sizes, prev, pager, next",
                    total: _vm.page.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.page, "pageIndex", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.page, "pageIndex", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }